import { CLIENT_SEARCH_PLACEHOLDER } from '#pplx/frontend/stream/createPlaceholderResults.js';
import { DEFAULT_SEARCH_PLACEHOLDER } from '#pplx/frontend/stream/createPlaceholderSearchResult.js';
export function isPlaceholderResult(entryId) {
    return entryId === CLIENT_SEARCH_PLACEHOLDER || entryId === DEFAULT_SEARCH_PLACEHOLDER;
}
export function wasThreadCreatedLocally(streams, identifiers) {
    const threadIdentifiers = new Set(identifiers.filter((identifier) => !!identifier));
    if (threadIdentifiers.size === 0)
        return false;
    return streams.some((stream) => {
        if (!stream.isNewThread)
            return false;
        const streamIdentifiers = [
            stream.id.description,
            stream.threadId,
            stream.entryId,
            stream.params?.frontend_context_uuid,
            stream.placeholderChunk?.backend_uuid,
            stream.placeholderChunk?.context_uuid,
            stream.placeholderChunk?.frontend_context_uuid,
            stream.placeholderChunk?.frontend_uuid,
            stream.placeholderChunk?.thread_url_slug,
        ];
        return streamIdentifiers.some((identifier) => identifier != null && threadIdentifiers.has(identifier));
    });
}
/**
 * Check if the params are SubmitParams.
 *
 * @param params - Parameters for the stream
 * @returns Whether the params are SubmitParams
 */
export function isSubmitParams(params) {
    if (!params) {
        return false;
    }
    return !params.resume_entry_uuid;
}
/**
 * Creates a rate-limited version of a function
 * @param func - Function to rate limit
 * @param config - Rate limit configuration
 * @returns Rate-limited function that returns a promise indicating if the call was allowed
 */
export function createRateLimitedFunction(func, config) {
    const state = {
        minuteCount: 0,
        hourCount: 0,
        minuteWindow: Math.floor(Date.now() / (60 * 1000)), // Current minute
        hourWindow: Math.floor(Date.now() / (60 * 60 * 1000)), // Current hour
    };
    return async (...args) => {
        const now = Date.now();
        const currentMinute = Math.floor(now / (60 * 1000));
        const currentHour = Math.floor(now / (60 * 60 * 1000));
        // Reset counters if we've moved to a new time window
        if (currentMinute !== state.minuteWindow) {
            state.minuteCount = 0;
            state.minuteWindow = currentMinute;
        }
        if (currentHour !== state.hourWindow) {
            state.hourCount = 0;
            state.hourWindow = currentHour;
        }
        // Check if we're within rate limits
        if (state.minuteCount >= config.perMinute) {
            return { allowed: false };
        }
        if (state.hourCount >= config.perHour) {
            return { allowed: false };
        }
        // Increment counters
        state.minuteCount++;
        state.hourCount++;
        // Execute the function
        const result = await func(...args);
        return { allowed: true, result };
    };
}
/**
 * Add an entry to a thread
 * @param oldThreads - Old threads
 * @param threadId - Thread ID
 * @param entryId - Entry ID
 * @returns New threads
 */
export function addEntryToThreads(oldThreads, threadId, entryId, { position = 'append' } = {}) {
    const threads = [...oldThreads];
    const threadIndex = threads.findIndex((thread) => thread.id === threadId);
    const oldThread = threads[threadIndex];
    if (oldThread) {
        if (oldThread.entryIds.includes(entryId)) {
            return oldThreads;
        }
        threads[threadIndex] = {
            ...oldThread,
            entryIds: position === 'prepend'
                ? [entryId, ...oldThread.entryIds]
                : [...oldThread.entryIds, entryId],
        };
    }
    else {
        threads.push({ id: threadId, entryIds: [entryId] });
    }
    return threads;
}
//# sourceMappingURL=utils.js.map